(function() {
  const LINE_SPACING_BASE = 1.2;
  const PX_TO_CM = 2.54 / 96;
  const MIN_LINE_HEIGHT_CM = 1.5;
  const MAX_WIDTH_CM = 210;
  const MAX_HEIGHT_CM = 110;
  const BASE_FONT_SIZE = 100;

  let FONT_CONFIG = {};
  let loadedFonts = {};
  let currentFontName = null;

  let lines = [];
  let draw;

  let desiredWidthCm = null;
  let desiredHeightCm = null;
  let lastEdited = null; // 'width' oder 'height'
  let updatingInputs = false;

  document.addEventListener('DOMContentLoaded', function() {
    const svgEl = document.getElementById('text-preview');
    const addLineBtn = document.getElementById('add-line-btn');
    const widthInput = document.getElementById('target-width-cm');
    const heightInput = document.getElementById('target-height-cm');

    if (!svgEl || !addLineBtn) {
      console.warn('[Wunschtext] SVG oder Buttons nicht gefunden – Script beendet.');
      return;
    }

    draw = SVG(svgEl);

    initFontConfigAndLoad();

    addLineBtn.addEventListener('click', function() {
      addLine();
    });

    // Breite/Höhe: nur bei change/blur übernehmen
    function attachSizeHandler(input, kind) {
      ['change', 'blur'].forEach(function(evt) {
        input.addEventListener(evt, function() {
          if (updatingInputs) return;

          const raw = (input.value || '').toString().replace(',', '.');
          const v = parseFloat(raw);

          if (kind === 'width') {
            desiredWidthCm = isNaN(v) ? null : v;
            lastEdited = 'width';
          } else {
            desiredHeightCm = isNaN(v) ? null : v;
            lastEdited = 'height';
          }

          renderPreview();
        });
      });
    }

    if (widthInput)  attachSizeHandler(widthInput,  'width');
    if (heightInput) attachSizeHandler(heightInput, 'height');

    // Plus/Minus Buttons
    document.querySelectorAll('.size-step-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const targetKind = btn.dataset.target;
        const dir = btn.dataset.dir === '-' ? -1 : 1;
        const input = targetKind === 'width' ? widthInput : heightInput;
        if (!input) return;

        const step = parseFloat(input.step) || 0.1;
        const raw = (input.value || '').toString().replace(',', '.');
        let cur = parseFloat(raw);
        if (isNaN(cur)) cur = 0;

        cur = cur + dir * step;

        if (input.min !== '') cur = Math.max(cur, parseFloat(input.min));
        if (input.max !== '') cur = Math.min(cur, parseFloat(input.max));

        input.value = cur.toFixed(1);
        const ev = new Event('change', { bubbles: true });
        input.dispatchEvent(ev);
      });
    });

    // erste Standardzeile
    addLine({
      text: 'Wunschtext',
      sizePercent: 100,
      color: '#000000',
      align: 'center',
      fontName: currentFontName
    });
  });

  function initFontConfigAndLoad() {
    const select = document.getElementById('font-select');
    if (!select) return;

    Array.from(select.options).forEach(function(opt) {
      const name = opt.value;
      const url = opt.dataset.font;
      if (name && url) {
        FONT_CONFIG[name] = url;
      }
    });

    currentFontName = select.value || Object.keys(FONT_CONFIG)[0];

    Object.entries(FONT_CONFIG).forEach(function([name, url]) {
      opentype.load(url, function(err, font) {
        if (err) {
          console.error('[Wunschtext] Font konnte nicht geladen werden:', name, err);
          return;
        }
        loadedFonts[name] = font;
        renderPreview();
      });
    });
  }

  // nur eine Zeile bekommt "default" (für CSS-Reduktion)
  // und wenn genau eine Zeile vorhanden ist: Zeilengrösse auf 100% resetten
  function updateDefaultClass() {
    const container = document.getElementById('lines-container');
    if (!container) return;

    const items = container.querySelectorAll('.line-control');

    items.forEach(function(el) {
      el.classList.remove('default');
    });

    if (items.length === 1) {
      const el = items[0];
      el.classList.add('default');

      // Zeilengrösse im UI und im Datenmodell auf 100% zurücksetzen
      const sizeInput = el.querySelector('.wunschtext-line-size-input');
      if (sizeInput) {
        sizeInput.value = '100';

        const lineId = el.dataset.lineId;
        const lineObj = lines.find(function(l) { return l.id === lineId; });
        if (lineObj) {
          lineObj.sizePercent = 100;
        }

        // Optional: sichtbaren Text im Fake-Select-Header anpassen
        const sizeHeaderText = el.querySelector('.dynamic-select-size .dynamic-select-header .dynamic-select-option-text');
        if (sizeHeaderText) {
          sizeHeaderText.textContent = '100%';
        }
      }
    }
  }

  // Namen der Line-Item-Properties pro Zeile neu durchnummerieren
  function renumberLinePropertyNames() {
    const container = document.getElementById('lines-container');
    if (!container) return;

    const items = container.querySelectorAll('.line-control');

    items.forEach(function(el, index) {
      const n = index + 1; // Text1, Text2, ...

      const textInput  = el.querySelector('.wunschtext-line-text');
      const fontInput  = el.querySelector('.wunschtext-line-font-input');
      const colorInput = el.querySelector('.wunschtext-line-color-input');
      const stepLabel  = el.querySelector('.line-control-step');

      // Zeilen-Label "Zeile 1", "Zeile 2", ...
    if (stepLabel) {
      stepLabel.textContent = 'Zeile ' + n;
    }

      if (textInput) {
        textInput.name = 'properties[Text' + n + ']';
      }
      if (fontInput) {
        // Schreibweise wie in deinem HTML: Schrifart
        fontInput.name = 'properties[Schrifart' + n + ']';
      }
      if (colorInput) {
        colorInput.name = 'properties[Folienfarbe' + n + ']';
      }
    });
  }

  function addLine(initial) {
    initial = initial || {};

    const id = Date.now().toString() + Math.random().toString(16).slice(2);

    const line = {
      id: id,
      text: initial.text || 'Wunschtext',
      sizePercent: typeof initial.sizePercent === 'number' ? initial.sizePercent : 100,
      color: initial.color || '#000000',
      align: initial.align || 'center',
      fontName: initial.fontName || currentFontName || Object.keys(FONT_CONFIG)[0],
      spacing: initial.spacing || 1.0
    };

    lines.push(line);
    renderLineControls(line);
    renderPreview();
  }

  function renderLineControls(line) {
    const container = document.getElementById('lines-container');
    const template = document.getElementById('line-template');
    if (!container || !template) return;

    const fragment = template.content.cloneNode(true);
    const wrapper = fragment.querySelector('.line-control');
    if (!wrapper) return;

    wrapper.dataset.lineId = line.id;

    const textInput    = wrapper.querySelector('.wunschtext-line-text');
    const fontInput    = wrapper.querySelector('.wunschtext-line-font-input');
    const colorInput   = wrapper.querySelector('.wunschtext-line-color-input');
    const sizeInput    = wrapper.querySelector('.wunschtext-line-size-input');
    const alignInput   = wrapper.querySelector('.wunschtext-line-align-input');
    const spacingInput = wrapper.querySelector('.wunschtext-line-spacing-input');
    const removeBtn    = wrapper.querySelector('.wunschtext-line-remove');

    // TEXT
    if (textInput) {
      textInput.value = line.text;
      textInput.addEventListener('input', function(e) {
        line.text = e.target.value;
        renderPreview();
      });
    }

    // FONT (Fake-Select → hidden input)
    if (fontInput) {
      if (!fontInput.value) {
        fontInput.value = line.fontName;
      } else {
        line.fontName = fontInput.value;
      }

      fontInput.addEventListener('change', function(e) {
        line.fontName = e.target.value || currentFontName;
        renderPreview();
      });
    }

    // COLOR (Fake-Select → hidden input) – jetzt mit color-value statt value
if (colorInput) {
  // Initiale Farbe aus color-value holen
  const initialColor =
    colorInput.getAttribute('color-value') ||
    colorInput.value ||
    '#000000';

  line.color = initialColor;

  // Listener: Farbe erneut aus color-value lesen
  colorInput.addEventListener('change', function(e) {
    const newColor =
      e.target.getAttribute('color-value') ||
      '#000000';

    line.color = newColor;
    renderPreview();
  });
}


    // SIZE (Fake-Select → hidden input, Prozent)
    if (sizeInput) {
      if (sizeInput.value) {
        let v = parseFloat(sizeInput.value);
        if (!isNaN(v)) line.sizePercent = v;
      } else {
        sizeInput.value = String(line.sizePercent);
      }

      sizeInput.addEventListener('change', function(e) {
        let v = parseFloat(e.target.value);
        if (isNaN(v)) v = 100;
        line.sizePercent = v;
        renderPreview();
      });
    }

    // ALIGN (Fake-Select → hidden input)
    if (alignInput) {
      if (alignInput.value) {
        line.align = alignInput.value;
      } else {
        alignInput.value = line.align;
      }

      alignInput.addEventListener('change', function(e) {
        line.align = e.target.value || 'center';
        renderPreview();
      });
    }

    // SPACING (Fake-Select → hidden input)
    if (spacingInput) {
      if (spacingInput.value) {
        let v = parseFloat(spacingInput.value);
        if (!isNaN(v)) line.spacing = v;
      } else {
        spacingInput.value = line.spacing.toFixed(1);
      }

      spacingInput.addEventListener('change', function(e) {
        let v = parseFloat((e.target.value || '').replace(',', '.'));
        if (isNaN(v)) v = 1.0;
        if (v < 0.5) v = 0.5;
        if (v > 2.5) v = 2.5;
        line.spacing = v;
        renderPreview();
      });
    }

    // REMOVE
    if (removeBtn) {
      removeBtn.addEventListener('click', function() {
        lines = lines.filter(function(l) { return l.id !== line.id; });
        wrapper.remove();

        // nach Löschen: Properties neu nummerieren + default-Status neu setzen
        renumberLinePropertyNames();
        updateDefaultClass();

        renderPreview();
      });
    }

    container.appendChild(fragment);

    // nach jedem Hinzufügen: Properties neu nummerieren + default-Status neu setzen
    renumberLinePropertyNames();
    updateDefaultClass();

    // neu hinzugefügte Fake-Selects initialisieren
    if (window.initAllDynamicSelects) {
      window.initAllDynamicSelects(wrapper);
    }
  }

  function transformPath(path, scale, dx, dy) {
    const commands = path.commands || [];
    commands.forEach(function(cmd) {
      if ('x'  in cmd) cmd.x  = cmd.x * scale  + dx;
      if ('y'  in cmd) cmd.y  = cmd.y * scale  + dy;
      if ('x1' in cmd) cmd.x1 = cmd.x1 * scale + dx;
      if ('y1' in cmd) cmd.y1 = cmd.y1 * scale + dy;
      if ('x2' in cmd) cmd.x2 = cmd.x2 * scale + dx;
      if ('y2' in cmd) cmd.y2 = cmd.y2 * scale + dy;
    });
  }

  function renderPreview() {
    if (!draw) return;

    draw.clear();

    if (!lines.length) {
      draw.viewbox(0, 0, 10, 10);
      updateSizeInfo(null, null);
      return;
    }

    const tempEntries = [];
    let maxWidth = 0;

    // 1) Pfade erzeugen, BoundingBoxen sammeln
    lines.forEach(function(line) {
      const text = line.text || ' ';
      const fontName = line.fontName || currentFontName;
      const font = loadedFonts[fontName];
      if (!font) return;

      const sizePercent = typeof line.sizePercent === 'number' ? line.sizePercent : 100;
      const fontSize = BASE_FONT_SIZE * (sizePercent / 100);

      const path = font.getPath(text, 0, 0, fontSize);
      const bb = path.getBoundingBox();
      const lineHeightPx = (bb.y2 - bb.y1) || fontSize;

      const width = bb.x2 - bb.x1;
      if (width > maxWidth) maxWidth = width;

      tempEntries.push({
        path,
        bb,
        lineHeightPx,
        color: line.color,
        align: line.align || 'center',
        spacing: line.spacing || 1.0
      });
    });

    if (!tempEntries.length || maxWidth <= 0) {
      draw.viewbox(0, 0, 10, 10);
      updateSizeInfo(null, null);
      return;
    }

    // 2) Zeilen horizontal ausrichten
    const pathEntries = [];
let currentY = 0;
let prevLineHeightPx = 0;

const refLeft = 0;
const refRight = maxWidth;
const refCenter = maxWidth / 2;

tempEntries.forEach(function(entry, index) {
  const { path, bb, lineHeightPx, color, align, spacing } = entry;

  // Abstand NACH OBEN:
  // Für die erste Zeile kein Abstand, ab der zweiten Zeile
  // wird der Abstand anhand des spacing-Werts DIESES Eintrags berechnet.
  if (index === 0) {
    currentY = 0;
  } else {
    const spaceFactor = (typeof spacing === 'number' && !isNaN(spacing)) ? spacing : 1.0;
    currentY += prevLineHeightPx * LINE_SPACING_BASE * spaceFactor;
  }

  prevLineHeightPx = lineHeightPx;

  const lineLeft = bb.x1;
  const lineRight = bb.x2;
  const lineCenter = (bb.x1 + bb.x2) / 2;

  let shiftX = 0;
  if (align === 'left') {
    shiftX = refLeft - lineLeft;
  } else if (align === 'right') {
    shiftX = refRight - lineRight;
  } else {
    shiftX = refCenter - lineCenter;
  }

  const shiftY = currentY - bb.y1;

  const commands = path.commands || [];
  commands.forEach(function(cmd) {
    if ('x' in cmd)  cmd.x  += shiftX;
    if ('y' in cmd)  cmd.y  += shiftY;
    if ('x1' in cmd) cmd.x1 += shiftX;
    if ('y1' in cmd) cmd.y1 += shiftY;
    if ('x2' in cmd) cmd.x2 += shiftX;
    if ('y2' in cmd) cmd.y2 += shiftY;
  });

  pathEntries.push({ path, color });
});


    // 3) Gesamte BoundingBox
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    pathEntries.forEach(function(entry) {
      const bb = entry.path.getBoundingBox();
      if (bb.x1 < minX) minX = bb.x1;
      if (bb.y1 < minY) minY = bb.y1;
      if (bb.x2 > maxX) maxX = bb.x2;
      if (bb.y2 > maxY) maxY = bb.y2;
    });

    const padding = 0;
    const rawWidth  = (maxX - minX) + padding * 2;
    const rawHeight = (maxY - minY) + padding * 2;

    const rawWidthCm  = rawWidth  * PX_TO_CM;
    const rawHeightCm = rawHeight * PX_TO_CM;

    // 4) physische Sticker-Grösse berechnen
    let scale = 1;

    if (rawWidthCm > 0 && rawHeightCm > 0) {
      if (lastEdited === 'width' && desiredWidthCm && desiredWidthCm > 0) {
        scale = desiredWidthCm / rawWidthCm;
      } else if (lastEdited === 'height' && desiredHeightCm && desiredHeightCm > 0) {
        scale = desiredHeightCm / rawHeightCm;
      } else if (desiredWidthCm && desiredWidthCm > 0) {
        scale = desiredWidthCm / rawWidthCm;
      } else if (desiredHeightCm && desiredHeightCm > 0) {
        scale = desiredHeightCm / rawHeightCm;
      }

      const minTotalHeightCm = lines.length * MIN_LINE_HEIGHT_CM;
      let minScale = 0;
      if (minTotalHeightCm > 0) {
        minScale = minTotalHeightCm / rawHeightCm;
      }

      let maxScaleWidth  = MAX_WIDTH_CM  / rawWidthCm;
      let maxScaleHeight = MAX_HEIGHT_CM / rawHeightCm;
      let maxScale = Math.min(maxScaleWidth, maxScaleHeight);
      if (!isFinite(maxScale) || maxScale <= 0) maxScale = Infinity;

      if (scale <= 0 || !isFinite(scale)) scale = 1;

      if (scale < minScale) scale = minScale;
      if (scale > maxScale) scale = maxScale;
    }

    const finalWidthCm  = rawWidthCm  * scale;
    const finalHeightCm = rawHeightCm * scale;

    syncSizeInputs(finalWidthCm, finalHeightCm);
    updateSizeInfo(finalWidthCm, finalHeightCm);

    // 5) Preview-Skalierung (unabhängig von realer cm-Grösse)
    let previewScale = 1;
    const PREVIEW_MAX_W = 800;
    const PREVIEW_MAX_H = 400;

    if (rawWidth > 0 && rawHeight > 0) {
      const sx = PREVIEW_MAX_W / rawWidth;
      const sy = PREVIEW_MAX_H / rawHeight;
      previewScale = Math.min(sx, sy, 1);
    }

    const widthScaled  = rawWidth  * previewScale;
    const heightScaled = rawHeight * previewScale;

    const offsetX = -(minX * previewScale);
    const offsetY = -(minY * previewScale);

    const group = draw.group();
    pathEntries.forEach(function(entry) {
      transformPath(entry.path, previewScale, offsetX, offsetY);
      const d = entry.path.toPathData(2);
      group.path(d).fill(entry.color || '#000000');
    });

    draw.viewbox(0, 0, widthScaled, heightScaled);

    const svgEl = document.getElementById('text-preview');
    if (svgEl) {
      svgEl.setAttribute('width', widthScaled);
      svgEl.setAttribute('height', heightScaled);
    }
  }

  function syncSizeInputs(wCm, hCm) {
    const widthInput = document.getElementById('target-width-cm');
    const heightInput = document.getElementById('target-height-cm');
    if (!widthInput || !heightInput || !wCm || !hCm) return;

    updatingInputs = true;
    widthInput.value = wCm.toFixed(1);
    heightInput.value = hCm.toFixed(1);
    desiredWidthCm = wCm;
    desiredHeightCm = hCm;
    updatingInputs = false;
  }

  function updateSizeInfo(wCm, hCm) {
    const el = document.getElementById('size-info');
    if (!el || !wCm || !hCm) {
      if (el) el.textContent = '–';
      return;
    }
    el.textContent = wCm.toFixed(1) + ' × ' + hCm.toFixed(1) + ' cm';
  }
})();